const tokenStorageKey = 'Nzfl95qluW'
export const getAuthToken = () => localStorage.getItem(tokenStorageKey)
export const setAuthToken = (value: string) => localStorage.setItem(tokenStorageKey, value)